import Panel from 'components/Panel'
import List from 'components/List'

export const HelpfulTopics = ({
  tutorials,
  faqs,
  deviceId,
  renderItemList
}) => (
  <Panel title="Other Helpful Topics">
    {tutorials.length !== 0 && (
      <List title="Tutorials:">{renderItemList(tutorials, { deviceId })}</List>
    )}

    {faqs.length !== 0 && (
      <List title="FAQs:">{renderItemList(faqs, { deviceId })}</List>
    )}

    {faqs.length === 0 && tutorials.length === 0 && (
      <p>There no other helpful topics at this moment.</p>
    )}
  </Panel>
)

export default HelpfulTopics
